import angular from 'angular';

import MouvementStockRoute from './_config/mouvement.stock.routes';
import MouvementStockConfiguration from './_config/mouvement.stock.config';
import MouvementStockComponent from './components/mouvement-stock';
import MouvementStockProduitInfosComponent from './components/mouvement-stock-produit-infos';

import MouvementStocksService from './services/mouvement.stock.service';

const moduleName = 'app.massia.gestion.mouvement.stock';

angular
	.module(moduleName, [])
	.config(MouvementStockRoute)
	.config(MouvementStockConfiguration)
	.component('mouvementStock', MouvementStockComponent)
	.component('mouvementStockProduitInfos', MouvementStockProduitInfosComponent)

	.service('MouvementStockService', MouvementStocksService);

export default moduleName;
